import { SeoAttributes } from 'ish-core/models/seo-attributes/seo-attributes.model';

import { CustomDotCmsPageMetaInfo } from '../../models/page/custom-dot-cms-page.model';

//eslint-disable-next-line complexity
export const getDotCmsSeoAttributesFromPageMeta = (attributes: CustomDotCmsPageMetaInfo): SeoAttributes => ({
  title: attributes?.pageTitle || attributes?.title || 'seo.defaults.title',
  description: attributes?.metaDescription || attributes?.description || 'seo.defaults.description',
  robots: attributes?.searchEngineIndex || 'index, follow',
  canonicalUrl: attributes?.canonicalUrl,
  keywords: attributes?.seokeywords || attributes?.metaKeywords,
  'og:title': attributes?.ogTitle || attributes?.pageTitle || attributes?.title || 'seo.defaults.title',
  'og:type': attributes?.ogType || 'website',
  'og:description':
    attributes.ogDescription || attributes.seodescription || attributes.description || 'seo.defaults.description',
  'og:image': attributes?.ogImage ? `/dA/${attributes?.ogImage}` : '/assets/img/og-image-default.jpg',
});
